import React from "react";
import noChatBG from "../../Assets/Images/noChatBG.png"; // ✅ Renamed to avoid conflict
import { RiUserAddLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import profile_Img from "../../Assets/Images/user.png";

const NoChats = () => {
  const { userInfo } = useSelector((state) => state.authUser);

  return (
    <div
      className="h-full flex flex-col items-center justify-center text-center bg-cover bg-center px-4 bg-[#f9f6fe] dark:bg-slate-950"
      style={{
        backgroundImage: `url(${noChatBG})`, // ✅ Use imported image here
      }}
    >
      <img
        alt="avatar"
        className="w-[100px] h-[100px] rounded-full object-cover mb-4"
        src={
          userInfo?.avtarImage ||
          userInfo?.userImage ||
          userInfo?.userMedia ||
          profile_Img
        }
      />
      <h2 className="text-2xl font-semibold text-black dark:text-zinc-100 mb-2">
        Welcome {userInfo.name} 👋
      </h2>

      <p className="text-[#7C7C7C] dark:text-zinc-400 max-w-2xl mb-4">
        Start a conversation by considering your audience—friends, colleagues,
        or interest groups. A simple outreach can lead to new collaborations or
        friendships!
      </p>
    </div>
  );
};

export default NoChats;
